import { UrlManager } from '@skapiec/lib-url-manager';

const replaceState = (filters: string[], sort: string): void => {
    const pathname = window.location.pathname.split('/');
    const categoryId = parseInt(pathname[3]);
    const productId = parseInt(pathname[5]);

    const newState = UrlManager.product.view({
        productId, categoryId, query: {
            filters: filters?.join(','),
            sort
        }
    });

    window.history.replaceState(null, '', newState);
};

export default replaceState;
